export default "__VITE_ASSET__WLk1kdeR__"